import { type ElementType, type PropsWithChildren } from "react";
import clsx from "clsx";

export default function Row({
  className,
  children,
  center,
  as,
  onClick,
}: PropsWithChildren<{
  className?: string;
  center?: "x" | "y" | "both";
  as?: ElementType;
  onClick?: () => void;
}>) {
  const Component = as ?? "div";
  return (
    <Component
      className={clsx("flex items-center", className, {
        "justify-center": center === "x" || center === "both",
        "items-center": center === "y" || center === "both",
      })}
      onClick={onClick}
    >
      {children}
    </Component>
  );
}
